import(/* webpackMode: "eager" */ "/home/runner/work/stackd-perps/stackd-perps/packages/stackd-perps/app/global-error.tsx");
